module.exports = __webpack_public_path__ + "img/loading-head.65ff63db.gif";